import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { memberProfileModalPaths } from "@/react/helpers/urlHelpers";
import { usePreviousLocationState } from "@/react/hooks/usePreviousLocationState";

import { IconButton } from "../../IconButton";

export const NotificationSettingsButton = () => {
  const navigate = useNavigate();
  const previousLocationState = usePreviousLocationState();

  return (
    <TippyV2 interactive={false} content={t("header_v3.notification_settings")}>
      <IconButton
        name="16-settings-gear"
        iconSize={20}
        ariaLabel={t("header_v3.notification_settings")}
        onClick={() => {
          void navigate({
            to: memberProfileModalPaths.notifications,
            state: previousLocationState,
          });
        }}
        iconClassName="!text-dark"
      />
    </TippyV2>
  );
};
